"use strict";

require("core-js/modules/es.array.iterator");

module.exports = once;

function once(f) {
  let done = false,
      res = null;
  return (...args) => done ? res : (done = true, res = f(...args));
}